App.controller('setupMemberAppointmentTypesPopup', ($scope, $rootScope, $api, responseHelper, AppointmentCategory, FeatureFlag) => {
  $scope.canCustomizeDuration = false;

  FeatureFlag.$find('sass_customize_appt_type_duration_by_provider_temp_20220427').$then((data) => {
    $scope.canCustomizeDuration = data.sass_customize_appt_type_duration_by_provider_temp_20220427
  });

  locationParams = (params = {}) => {
    return _.merge(params, { location_id: $rootScope.location.id })
  }

  $scope.minutes_options = _.range(5, 305, 5)
  $scope.showDurationCustomization = false;

  $scope.toggleDurationCustomization = () => {
    $scope.showDurationCustomization = !$scope.showDurationCustomization;

    if(!$scope.showDurationCustomization) {
      setDefaultAppointmentTypeDurationValues();
    }
  }

  setDefaultAppointmentTypeDurationValues = () => {
    $scope.more_appt_categories_loading = true;

    AppointmentCategory.$search(locationParams()).$then((data) => {
      resetApptTypeDurations(data);
    }).$finally(() => {
      $scope.more_appt_categories_loading = false
      $scope.saveNeeded = true;
    });
  }

  resetApptTypeDurations = (institutionAppointmentTypes) => {
    institutionAppointmentTypes.forEach((instCategory) => {
      $scope.appointment_types.forEach((providerCategory) => {
        if (instCategory.name === providerCategory.name) {
          providerCategory.minutes = instCategory.minutes;
        }
      });
    })
  };

  $scope.showChangeWarning = () => {
    $scope.saveNeeded = true;
  }

  $scope.customizeAppointmentText = () => {
    return $scope.showDurationCustomization ?  "Use default appointment durations" : "Customize appointment durations"
  }

  $scope.formatAppointTypes = (data) => _.map(data, (cat) => {
    const appt_type = _.find($scope.member.appointment_types, (appt_type) => appt_type.appt_category.id === cat.id) || {}
    return {
      id: appt_type.id,
      appt_category_id: cat.id,
      name: appt_type.name || cat.name,
      category: appt_type.category || cat.category,
      provider_id,
      minutes: appt_type.minutes || cat.minutes,
      parent_type: appt_type.parent_type || $scope.member_type,
      parent_id: appt_type.parent_id || $scope.member.id,
      institution_id: appt_type.institution_id || $rootScope.institution.id,
      enabled: appt_type.id !== undefined
    }
  })

  if ($scope.ngDialogData && $scope.ngDialogData.member) {
    $scope.member = $scope.ngDialogData.member
    provider_id = $scope.member_wording === 'provider' ? $scope.member.id : null
    $scope.appointment_types = $scope.formatAppointTypes($scope.appt_categories)
  }

  $scope.saveAppointmentTypes = () => {
    appointment_types = _.filter($scope.appointment_types, (appt_type) => appt_type.enabled || appt_type.id)
    if (!appointment_types.length) { return }

    appointment_types = _.map(appointment_types, (appt_type) => {
      if (appt_type.enabled) {
        delete appt_type._destroy
      } else {
        appt_type._destroy = true
      }

      return _.pick(appt_type, 'id', 'institution_id', 'provider_id', 'appt_category_id', 'name', 'category', 'minutes', '_destroy')
    })

    params = Object.assign({
      appointment_types,
      location_id: $rootScope.location.id,
      parent_type: $scope.member_type
    }, $scope.member_type === 'Operatory' ? { parent_uuid: $scope.member.uuid } : { parent_id: $scope.member.id })

    $scope.appointment_types_saving = true
    $api('POST', '/appointment_types/bulk_update/', {}, params).then((resp) => {
      if (resp.data.code) {
        responseHelper.toasterResponse(resp.data.description, 'success', 'Success')
        if(typeof($scope.closeThisDialog) == 'function'){
          $scope.closeThisDialog({ saved: true, appointment_types: resp.data.data })
        }
      } else {
        responseHelper.toasterResponse(resp.data.error, 'error', 'Error')
      }
      $scope.appointment_types_saving = false
      $scope.saveNeeded = false;
    })
  }

  resetScopeSearch = () => {
    $scope.scope_search = { page: 0, per_page: 15, hit_end: false };
  };

  resetScopeSearch();

  locationParams = (params = {}) => {
    params['location_id'] = $rootScope.location.id
    return params
  }

  $scope.loadMoreApptCategories = () => {
    if ($scope.more_appt_categories_loading || $scope.scope_search.hit_end) return

    $scope.scope_search.page++
    $scope.more_appt_categories_loading = true

    resp = AppointmentCategory.$search(
      _.merge(
        locationParams(),
        { page: $scope.scope_search.page }
      )
    )
    resp.$promise.then(data => {
      if (resp.$response && resp.$response.data && resp.$response.data.data.length) {
        const dataFormatted = $scope.formatAppointTypes(resp.$response.data.data)
        $scope.appointment_types = _.uniqBy($scope.appointment_types.concat(dataFormatted), 'appt_category_id')
      } else {
        $scope.scope_search.hit_end = true
      }

      $scope.more_appt_categories_loading = false
    })
  }
})
